import {get} from 'lodash';

export default (state = {}, {orderId, stateName, stateValue}: any) => {
  return {
    ...state,
    allOrderDetailState: {
      ...get(state, 'allOrderDetailState', {}),
      [orderId]: {
        ...get(state, `allOrderDetailState.${orderId}`, {}),
        [stateName]: stateValue,
      },
    },
  };
};
